import {
    CREATE_ORDER_REQUEST,
    CREATE_ORDER_REQUEST_SUCCESS,
    CREATE_ORDER_REQUEST_FAILURE,
    CANCEL_COLLECTION_REQUEST,
    CANCEL_COLLECTION_REQUEST_SUCCESS,
    CANCEL_COLLECTION_REQUEST_FAILURE,
} from '../constants/create_order.constants';

export const createOrderRequest = (id, kind, date_from, date_to) => ({
    type: CREATE_ORDER_REQUEST, id, kind, date_from, date_to,
});

export const createOrderRequestSuccess = payload => ({
    type: CREATE_ORDER_REQUEST_SUCCESS, payload,
});

export const createOrderRequestFailure = error => ({
    type: CREATE_ORDER_REQUEST_FAILURE, error,
});

export const cancelCollectionRequest = lead_id => ({
    type: CANCEL_COLLECTION_REQUEST, lead_id,
});

export const cancelCollectionRequestSuccess = payload => ({
    type: CANCEL_COLLECTION_REQUEST_SUCCESS, payload,
});

export const cancelCollectionRequestFailure = error => ({
    type: CANCEL_COLLECTION_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/create_order.actions.js